// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__waHIb","remark":"Spinner_remark__YdSs8","wrapper":"Spinner_wrapper__WEYmj","container":"Spinner_container__qSi7E"};